import { render, staticRenderFns } from "./PopOverTitle.vue?vue&type=template&id=cd513fac&"
import script from "./PopOverTitle.vue?vue&type=script&lang=js&"
export * from "./PopOverTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports